import {defineStore, storeToRefs} from 'pinia'
import { ref } from "vue";
import { useStatesStore } from "@/store/states.js";
import { useRouter } from "vue-router";
import { useAgencyTheme } from "@/composables/AgencyTheme.js";

export const useRegisterStore = defineStore('register', () => {
    const registerKey = ref(null);

    const fetch = async (key) => {
        try {
            const response = await axios.get('/api/register-key', {
                params: { key }
            });

            registerKey.value = response.data.data;
        } catch (e) {
            agency.value = null;
        }
    };

    return {
        registerKey,
        fetch,
    };
});
